import { render } from "./PedidoNuevo.vue?vue&type=template&id=13fc70fc&scoped=true"
import script from "./PedidoNuevo.vue?vue&type=script&lang=js"
export * from "./PedidoNuevo.vue?vue&type=script&lang=js"

import "./PedidoNuevo.vue?vue&type=style&index=0&id=13fc70fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fc70fc"]])

export default __exports__